import { z } from 'zod';

export const productSchema = z.object({
  category_id: z.string().min(1, 'parcels.products.errors.categoryRequired'),
  subcategory_id: z.string().min(1, 'parcels.products.errors.subcategoryRequired'),
  full_name: z
    .string()
    .trim()
    .min(2, 'parcels.products.errors.fullNameRequired')
    .max(200, 'parcels.products.errors.tooLong'),
  quantity: z.coerce
    .number({ message: 'parcels.products.errors.quantityInvalid' })
    .int('parcels.products.errors.quantityInvalid')
    .min(1, 'parcels.products.errors.quantityMin'),
  price_per_item: z.coerce
    .number({ message: 'parcels.products.errors.priceInvalid' })
    .gt(0, 'parcels.products.errors.priceMin'),
});

export type ProductFormValues = z.infer<typeof productSchema>;

export const emptyProductValues: ProductFormValues = {
  category_id: '',
  subcategory_id: '',
  full_name: '',
  quantity: 1,
  price_per_item: 0,
};
